module.exports = __webpack_public_path__ + "4d6caf27e157f44d7ba52b3120364280.pdf";